<script>
import TableView from "@/components/TableView.vue";
import { mapGetters, mapActions } from "vuex";
import common from "@/mixins/common";
import DatePicker from "@/components/DatePicker.vue";
export default {
  name: "lotteryRecord",
  components: {DatePicker, TableView},
  mixins: [common],
  data() {
    return {
      status: -2,
      loading: false,
      searchValue:'',
      startDate: '',
      endDate: '',
      pagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      bonusPagination: {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      list:[],
      reportInfo: {
        total: 0,
        returnBonusList:[],
        realTotal: 0,
        shippingPrice:0,
        signBonus: 0,
        fee: 0,
        vipBonus: 0,
        rent: 0
      },
      vendorList:[],
      selectVendor: ''
    };
  },
  created() {
    this.setDefaultDate();
    this.selectVendor = this.getUserInfo.userId;
    this.loadVendorList();
    this.loadData();
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getColumnKeys() {
      let list = [
        // { value:'productId', text:'系統編號編號', sortable: true },
        {value: 'displayId', text: '自訂商品編號', sortable: true},
        {value: 'imageUrl', text: '賞品圖片', sortable: false, isImage: true,},
        {value: 'name', text: '賞品名稱', sortable: true},
        {value: 'productCategory', text: '商品類別', sortable: false, options: this.getCategoryKeys, },
        {value: 'category', text: '賞品類別', sortable: false },
        {value: 'nickname', text: '抽到的會員', sortable: true},
        // {value: 'price', text: '售價', sortable: true},
        // {value: 'deliveryPrice', text: '設定運費', sortable: true},
        {value: 'createdDate', text: '抽到的時間', sortable: true},
      ];
      return list;
    },
    getSearchKeys() {
      return [
        { key: "name", value: "商品名稱" },
        { key: "productId", value: "商品編號" },
        { key: "displayId", value: "自訂商品編號" },
      ];
    },
    getCategoryKeys() {
      return [
        { key: 3, value: "紅利賞" },
        { key: 5, value: "刮刮樂" },
      ];
    },
  },
  methods: {
    ...mapActions(['getVendorFreeReportList', 'getVendorList']),
    isDifferenceMoreThanAMonth(date1, date2) {
      // 將日期字符串轉換為日期對象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 計算兩個日期之間的差異（以毫秒為單位）
      const differenceInTime = Math.abs(d2.getTime() - d1.getTime());

      // 計算差異天數
      const differenceInDays = differenceInTime / (1000 * 3600 * 24);

      // 檢查差異是否超過30天（大致一個月）
      return differenceInDays > 30;
    },
    setDefaultDate() {
      let todayDate = new Date();
      // todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      // futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(new Date(this.startDate).getDate() + 14);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    async loadVendorList() {
      try {
        const res = await this.getVendorList();
        const result = res.data;
        if (result.statusCode === 0) {
          this.vendorList = result.data;
        }
      } catch (e) {
        console.log(`getVendorList error `, e);
      }
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
    async loadData() {
      try {
        const query = {
          startDate: this.startDate,
          endDate: this.endDate,
          vendorId: this.selectVendor,
        }
        if (!query.vendorId || query.vendorId === '') return;

        if (this.isDifferenceMoreThanAMonth(query.startDate, query.endDate)) {
          this.showMessageDialog('提示', '查詢時間不可超過一個月！');
          return;
        }


        console.log(`loadData query  = ${JSON.stringify(query)}`)

        this.loading = true;
        const res = await this.getVendorFreeReportList(query);

        const result = res.data;
        if (result.statusCode === 0) {
          this.list = result.data.prizeList;
          console.log(`getVendorFreeReportList ${JSON.stringify(this.list)}`);
          this.pagination.totalItems = this.list.length;
        }
        this.loading = false;
      } catch (e) {
        console.log(`getVendorReportList error `, e);
        this.loading = false;
      }
    },
    /**
     * 頁面切換
     * @param page Object - { page: 頁數, itemsPerPage: 每頁幾筆 }
     * */
    changePage(page) {
      this.pagination.page = page.page;
      if (page.itemsPerPage === -1) {
        this.pagination.itemsPerPage = 1000;
      } else {
        this.pagination.itemsPerPage = page.itemsPerPage;
      }
      console.log(`changePage ${JSON.stringify(this.pagination)}`);
      this.loadData();
    },
    searchEvent() {
      this.loadData();
    },
    reset() {
      this.searchValue = '';
      this.loadData();
    },
    changeStartDate(date) {
      console.log(`changeStartDate = ${date}`)
      this.startDate = date;
    },
    changeEndDate(date) {
      console.log(`changeEndDate = ${date}`)
      this.endDate = date;
    },
  }
}
</script>

<template>
  <v-content>
    <v-layout v-if="isAdmin">
      <v-flex md4 xs12>
        <v-select class="ml-1" :items="vendorList" v-model="selectVendor" label="特約商店"
                  item-value="vendorId" item-text="name" :color="Theme.GREEN"></v-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md4 xs12>
        <v-layout row wrap>
          <v-flex md6 xs12>
            <date-picker class="ml-4" :date="startDate" @updateDate="changeStartDate" date-string="起始日期"/>
          </v-flex>
          <v-flex md6 xs12>
            <date-picker :date="endDate" @updateDate="changeEndDate" date-string="結束日期"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex class="mt-2">
        <v-btn class="mr-2" :color="Theme.GREEN" dark @click.prevent="searchEvent">搜尋</v-btn>
        <v-btn class="mr-2" :color="Theme.YELLOW" dark @click.prevent="reset">重置</v-btn>
      </v-flex>
    </v-layout>
    <br/>
    <v-layout>
      <v-flex>
        <table-view :items="list"
                    :columnKeys="getColumnKeys"
                    :pagination="pagination"
                    :loading="loading"
                    @changePage="changePage"/>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<style scoped>

</style>
